import SchoolGradeMagicOtp from "./SchoolGradeMagicOtp";

export default SchoolGradeMagicOtp;
